var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Stack } from "@mui/material";
var separatorIndex = 3;
export var LegendItem = function (_a) {
    var title = _a.title, value = _a.value, unit = _a.unit, titleColor = _a.titleColor, isBoldTitle = _a.isBoldTitle, action = _a.action;
    if (!title && !value && !unit && !titleColor) {
        return null;
    }
    var roundedValue = value ? value.toFixed() : "";
    var revertedValueWithDots = roundedValue
        ? roundedValue
            .toString()
            .split("")
            .reverse()
            .reduce(function (accumulator, currentValue, index) {
            var newAccumulator = accumulator;
            if (!(index % separatorIndex) && index) {
                newAccumulator = "".concat(accumulator, ".").concat(currentValue);
            }
            else {
                newAccumulator = "".concat(accumulator).concat(currentValue);
            }
            return newAccumulator;
        }, "")
        : "";
    var calculatedValue = revertedValueWithDots.split("").reverse().join("");
    return (_jsxs(Box, __assign({ mb: 1 }, { children: [title && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body2", color: titleColor, component: "span", onClick: function () { return action === null || action === void 0 ? void 0 : action(); }, sx: {
                            fontWeight: isBoldTitle ? "bold" : "normal",
                            cursor: "pointer",
                            "&:hover": {
                                textDecoration: "underline",
                            },
                        } }, { children: title })), _jsx(Typography, __assign({ variant: "body2", sx: {
                            position: "relative",
                            wordBreak: "break-word",
                            cursor: "pointer",
                            fontSize: 10,
                            top: -5,
                        }, color: titleColor, component: "span", onClick: function () { return action === null || action === void 0 ? void 0 : action(); } }, { children: "( i )" }))] })), _jsxs(Stack, __assign({ sx: { flexDirection: "row" } }, { children: [_jsx(Typography, __assign({ variant: "body1", sx: { wordBreak: "break-word" } }, { children: calculatedValue || "-,-" })), unit && (_jsx(Typography, __assign({ variant: "body1", sx: { wordBreak: "break-word", ml: 0.75 } }, { children: unit || "" })))] }))] })));
};
